import gql from 'graphql-tag'
import { PanelSupplierOrder } from '../../../data/model/order'

export interface AddPanelSupplierOrderData {
  addPanelSupplierOrders: PanelSupplierOrder
}

// This mutation includes the force argument to bypass dashboard-service restriction which
// means we cannot place a new order less tha 1 hour after the first order. This restriction
// is no longer needed and for full-launch we need to be able to place a new order quicker.
export const ADD_PANEL_SUPPLIER_ORDER = gql`
  mutation addPanelSupplierOrder(
    $surveyId: ID!
    $orderDescription: String!
    $samplesNeeded: Int!
    $panelSupplierCode: String!
  ) {
    addPanelSupplierOrder(
      panelSupplierCode: $panelSupplierCode
      surveyId: $surveyId
      orderDescription: $orderDescription
      samplesNeeded: $samplesNeeded
      force: true
    ) {
      orderId
      panelSupplierCode
      panelSupplierOrderId {
        value
      }
      status
      cpi
      orderNumber
      createdDate
      sinceDate
    }
  }
`

export const FULL_LAUNCH = gql`
  mutation fullLaunch(
    $surveyId: ID!
    $orderDescription: String!
    $samplesNeeded: Int!
  ) {
    fullLaunch(
      surveyId: $surveyId
      orderDescription: $orderDescription
      samplesNeeded: $samplesNeeded
    ) {
      survey {
        surveyId
        nickname
        name
        state
        createdDate
        sinceDate
      }
      provider
      message
    }
  }
`
